<template>
  <div class="maintenance">
    <h1>Maintenance Mode</h1>
    <p>Our website is currently undergoing scheduled maintenance. Scheduled maintenance continue through Sunday afternoon 7/27.</p>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceView',
}
</script>

<style>
.maintenance {
  text-align: center;
  margin-top: 20%;
}
</style>